import styled from 'styled-components';

export const Wrapper = styled.form`
  display: grid;
  width: 100%;
  gap: 24px;
  align-items: flex-end;
  grid-template-rows: min-content 1fr;

  > div:first-child {
    width: 464px;
    min-height: 150px;
  }

  > div:last-child {
    display: flex;
    flex-direction: column;
  }
`;

export const DividerStyled = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.color.grey200};
`;
